<template>
  <el-card>
    <div slot="header">
      <div class="title">{{ score_name }}</div>
    </div>
    <el-form ref="form" :model="listForm" label-width="80px" inline>
      <el-form-item>
        <el-input @clear="init" v-model="listForm.name" placeholder="请输入曲目名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="init" type="primary">查询</el-button>
      </el-form-item>
      <el-form-item class="fr">
        <div class="flex">
          <el-button @click="downloadTemplate" style="margin-right: 10px">下载模板</el-button>
          <uploader :target="importUrl" :params="listForm" @success="success" accept=".xlsx">
            <el-button type="primary">导入曲目</el-button>
          </uploader>
        </div>
      </el-form-item>
    </el-form>
    <el-table
        :data="list">
      <el-table-column
          prop="name"
          label="曲目名称">
      </el-table-column>
      <el-table-column
          prop="accompaniment.name"
          label="伴奏">
      </el-table-column>
      <el-table-column
          prop="play.name"
          label="演奏视频">
      </el-table-column>
      <el-table-column
          prop="overhead.name"
          label="俯拍视频">
      </el-table-column>
      <el-table-column
          prop="uv"
          label="UV">
      </el-table-column>
      <el-table-column
          prop="pv"
          label="PV">
      </el-table-column>
      <el-table-column label="排序">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.sort" controls-position="right" @change="(e)=>handleChange(e,scope.row)"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column
          min-width="300px"
          align="center"
          label="操作">
        <template slot-scope="scope">
          <el-button @click="getCode(scope)" type="text">乐器小程序码</el-button>
          <el-button @click="getCode(scope, true)" type="text">小卡乐器小程序码</el-button>
          <el-button @click="handleOpera(scope)" type="text">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-if="meta" :total="meta.total" :pagination="meta.pagination" :changed="changed"/>
    <song-edit ref="songEdit" @refresh="init"></song-edit>
    <download-img :visible="visible" :url="url" :name="name" @downed="visible = false"></download-img>
  </el-card>
</template>

<script>
import {createMiniCode, listSong, updateSong} from "@/api/music";
import songEdit from './components/song-edit'

export default {
  name: "song",
  components: {
    songEdit
  },
  data() {
    return {
      visible: false,
      url: undefined,
      name: undefined,
      score_name: undefined,
      list: [],
      meta: undefined,
      importUrl: 'music/song-template',
      listForm: {
        music_score_id: undefined,
        name: undefined,
        pagination: {
          currentPage: 1,
          limit: 20
        }
      },
    }
  },
  methods: {
    async handleChange(sort, row) {
      await updateSong({id: row.id, sort: sort})
      this.$message.success('排序修改成功')
    },
    async getCode({row = undefined}, isTrue) {
      if (!row.wxaCodeUrl || !row.videoCodeUrl) {
        const loading = this.$loading({
          text: '生成中...'
        })
        try {
          const data = await createMiniCode({id: row.id, type: 'song'})
          row.wxaCodeUrl = data.music
          row.videoCodeUrl = data.video_code
        } finally {
          loading.close()
        }
      }
      this.url = isTrue ? row.videoCodeUrl : row.wxaCodeUrl;
      this.name = row.name
      this.visible = true
    },
    changed(page) {
      this.listForm = Object.assign(this.listForm, {...page})
      this.init()
    },
    handleOpera({row = undefined}) {
      this.$refs.songEdit.show(row)
    },
    success(res) {
      this.$notify({
        title: '导入结果',
        dangerouslyUseHTMLString: true,
        duration: 0,
        message: `成功:${res.count}条;<br>空行:${res.emptyError}条;<br>错误信息:${res.error.join("<br>")}`
      });
      this.listForm.pagination.currentPage = 1
      this.init()
    },
    downloadTemplate() {
      this.$linkHelper.redirect(this.importUrl)
    },
    async init() {
      let {collection, meta} = await listSong(this.listForm)
      this.list = collection
      this.meta = meta
    }
  },
  mounted() {
    let {id, name} = this.$route.query
    this.score_name = name
    this.listForm.music_score_id = id
    this.init()
  }
}
</script>

<style scoped>

</style>
